// src/utils/contentful.js
import { createSlug } from "./slug";

export const splitToArray = (value) =>
  value ? value.split(",").map(v => v.trim()).filter(Boolean) : [];

export const getImageUrl = (asset) =>
  asset?.fields?.file?.url ? `https:${asset.fields.file.url}` : null;

export const mapContentfulItemToCard = (item, index) => ({
  id: item.sys?.id || index,
  title: item?.title,
  author: "UPENDO STORE Collection",
  price: Number(item?.price),
  image: getImageUrl(item?.backgroundImage || item.bgimage),
  description: item?.description,
  category: item?.category === "book" ? "books" : "accessories",
  type: item?.category,
  variants: {
    sizes: splitToArray(item?.sizes),
    colors: splitToArray(item?.colours)
  },
  slug: createSlug(item?.title)

});